export interface DeviceFilePreviewSource {
  key?: string | null;
  name?: string | null;
  url: string;
}

export type DeviceFilePreviewKind = 'image' | 'pdf' | 'txt' | 'other';

export class DeviceFilePreviewUtil {
  public static getFileName(source: DeviceFilePreviewSource): string {
    const normalizedName = source.name?.trim();
    if (normalizedName) {
      return normalizedName;
    }

    const withoutQuery = source.url.split('?')[0];
    const rawName = withoutQuery.split('/').pop() || withoutQuery;
    try {
      return decodeURIComponent(rawName);
    } catch {
      return rawName;
    }
  }

  public static getKind(source: DeviceFilePreviewSource): DeviceFilePreviewKind {
    const candidate = this.getComparableName(source);

    if (candidate.endsWith('.pdf')) {
      return 'pdf';
    }

    if (candidate.endsWith('.txt')) {
      return 'txt';
    }

    if (/\.(png|jpe?g|webp|gif|bmp|svg)$/i.test(candidate)) {
      return 'image';
    }

    return 'other';
  }

  public static isInlinePreview(source: DeviceFilePreviewSource): boolean {
    const kind = this.getKind(source);
    return kind === 'pdf' || kind === 'txt';
  }

  public static isImage(source: DeviceFilePreviewSource): boolean {
    return this.getKind(source) === 'image';
  }

  public static isPdf(source: DeviceFilePreviewSource): boolean {
    return this.getKind(source) === 'pdf';
  }

  public static getThumbFrameUrl(source: DeviceFilePreviewSource): string {
    if (!this.isPdf(source)) {
      return source.url;
    }

    return `${source.url}${source.url.includes('#') ? '&' : '#'}page=1&toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
  }

  private static getComparableName(source: DeviceFilePreviewSource): string {
    const nameCandidate = source.name?.trim() || source.url;
    return nameCandidate.split('?')[0].toLowerCase();
  }
}
